export interface UploadProps {
    broadcastId?: string;
}

export interface UploadsState {
    processingOrQueued: UploadProps[];
    ready: UploadProps[];
}

export enum VideoUploadStatus {
    Processing = "inprogress",
    Success = "ready",
    Queued = "queued"
}
